import * as actions from "./actionsTypes";

const initialData = {
  loaderTrainingType: false,
  trainingType: null,
  trainingTypeFail: null,
  saveLoaderTrainingType: false,
  trainingTypeFormError: null,
};

export default function TrainingTypeReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_TRAINING_TYPE:
      return { ...state, loaderTrainingType: action.payload };

    case actions.GET_TRAINING_TYPE:
      return { ...state, trainingType: action.payload };

    case actions.TRAINING_TYPE_FAIL:
      return { ...state, trainingTypeFail: action.payload };

    case actions.SAVE_LOADER_TRAINING_TYPE:
      return { ...state, saveLoaderTrainingType: action.payload };

    case actions.FORM_TRAINING_TYPE_FAIL:
      return { ...state, trainingTypeFormError: action.payload };

    default:
      return state;
  }
}
